import isFunction from './isFunction';

// ----------------------------------------------------------------------------

function isFunctionFor(...args: any): boolean {
    for (const item of args) {
        if (!isFunction(item)) {
            return false;
        }
    }

    return true;
}

// ----------------------------------------------------------------------------

export default isFunctionFor;
